import React from "react";
import { NavLink } from "react-router-dom";
import { useUserContext } from "../components/auth/userContext";

export const Sitemap = () => {
  const { userInfo } = useUserContext();

  return (
    <div className="content p-8 mx-auto">
      <h1 className="text-2xl font-bold text-center mb-6">網站導覽</h1>
      <h2 className="text-xl font-medium my-4">網站頁面</h2>
      <ul className="sitemap text-blue-600 list-disc pl-6 space-y-4 ml-4">
        <li>
          <a className="hover:underline" href="/">首頁</a></li>
        <li><a className="hover:underline" href="/aicontest">高雄市AI素養爭霸賽</a></li>
        <li><a className="hover:underline" href="/newsall">最新消息</a></li>
        <li>
          <span className="text-slate-700">單位介紹</span>
          <ul className="list-circle pl-6 space-y-2 mt-2">
            <li><a className="hover:underline" href="/origin">緣起與背景</a></li>
            <li><a className="hover:underline" href="/digital">數位學習推動辦公室</a></li>
            <li><a className="hover:underline" href="/bilingual">雙語學習推動辦公室</a></li>
            <li><a className="hover:underline" href="/star">數位恆星學校</a></li>
            <li><a className="hover:underline" href="/schoolmaster">校長科技領導學校</a></li>
          </ul>
        </li>
        <li>
          <span className="text-slate-700">服務項目</span>
          <ul className="list-circle pl-6 space-y-2 mt-2">
            <li><a className="hover:underline" href="/info">研習資訊</a></li>
            <li><a className="hover:underline" href="/repair">線上報修</a></li>
            <li><a href="https://mdm.edu.tw/" target="_blank" rel="noopener noreferrer" className="hover:underline">教育部 MOEMDM</a></li>
            <li><a className="hover:underline" href="/procurement">軟體採購</a></li>
            <li><a className="hover:underline" href="/plan">計畫專區</a></li>
            <li><a className="hover:underline" href="/download">下載專區</a></li>
          </ul>
        </li>
        {(userInfo) ?
          <>
            <li><a className="hover:underline" href="/main">教學資源</a></li>
            <li><a className="hover:underline" href="/lecturer">人才資源</a></li>
            <li><a className="hover:underline" href="/calendar">行事曆</a></li>
          </>
          :
          <>
            <li><a className="hover:underline" href="/resource">教學資源</a></li>
            <li><a className="hover:underline" href="/lecturer">人才資源</a></li>
            <li><a className="hover:underline" href="./api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main">行事曆(登入後使用)</a></li>
          </>
        }
        <li><a className="hover:underline" href="/activity">活動花絮</a></li>
        <li>
          <span className="text-slate-700">後台管理</span>
          <ul className="list-circle pl-6 space-y-2 mt-2">
            {(userInfo) ?
              <li><a className="hover:underline" href="/main/announce">公告管理</a></li>
              :
              <li><a className="hover:underline" href="./api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main">公告管理(登入後使用)</a></li>
            }
          </ul>
        </li>
        <li><a href="https://dlo.kh.edu.tw/" target="_blank" rel="noopener noreferrer" className="hover:underline">舊網站</a></li>
        {(userInfo) ?
          <li><a className="hover:underline" href="./api/auth/logout?restore_url=/">登出</a></li>
          :
          <li><a className="hover:underline" href="./api/auth/login_ischool?linkSignIn=khoidc&restore_url=/main">登入</a></li>
        }
        <li><a className="hover:underline" href="/privacy-policy">隱私政策</a></li>
      </ul>
    </div>
  );
};